export default __webpack_public_path__ + "static/media/breach3.84522658.png";